import React from 'react';
import { SiteConfigManager } from '@apollo/core';

const useIsShowingLogo = () => SiteConfigManager.getConfig('config.config.general.showLogos');

export default useIsShowingLogo;
